const REFERENCES_REVISION_STORAGE_KEY = 'referencesRevision';

interface StalenessParams {
  readonly hasCachedReferences: boolean;
  readonly latestRevision: string;
  readonly storedRevision: string | null;
}

// The cached references depend on the reference data (server revision) and
// on the shape of the references query: a new field must refetch them too.
export const buildReferencesCacheRevision = (
  serverRevision: string,
  referencesDocumentHash: string | undefined,
) =>
  referencesDocumentHash
    ? `${serverRevision}:${referencesDocumentHash}`
    : serverRevision;

export const isCachedReferencesStale = ({
  hasCachedReferences,
  latestRevision,
  storedRevision,
}: Readonly<StalenessParams>) =>
  hasCachedReferences && storedRevision !== latestRevision;

// localStorage can throw (private browsing, blocked site data): the revision is
// then treated as unknown, which only costs a references refetch.
export const readStoredReferencesRevision = (): string | null => {
  try {
    return localStorage.getItem(REFERENCES_REVISION_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const storeReferencesRevision = (revision: string) => {
  try {
    localStorage.setItem(REFERENCES_REVISION_STORAGE_KEY, revision);
  } catch {
    // The next start will refetch the references: nothing else to do.
  }
};
